import { useRef, useCallback } from "react";
import {
  toggleBold,
  toggleItalic,
  toggleCode,
  toggleQuote,
  toggleBulletList,
  toggleNumberedList,
  insertLink,
  insertHeader,
} from "markdown-actions";

export function useMarkdownToolbar(setContent) {
  const textareaRef = useRef(null);

  const exec = useCallback(
    (action, ...args) => {
      const ta = textareaRef.current;
      if (!ta) return;
      action(ta, ...args);
      setContent(ta.value);
      ta.focus();
    },
    [setContent],
  );

  return {
    textareaRef,
    bold: () => exec(toggleBold),
    italic: () => exec(toggleItalic),
    code: () => exec(toggleCode),
    quote: () => exec(toggleQuote),
    ul: () => exec(toggleBulletList),
    ol: () => exec(toggleNumberedList),
    link: () => exec(insertLink, { text: "link text", url: "https://" }),
    h1: () => exec(insertHeader, 1),
    h2: () => exec(insertHeader, 2),
    h3: () => exec(insertHeader, 3),
    insertImage: (url, alt) => {
      const ta = textareaRef.current;
      if (!ta) return;
      const start = ta.selectionStart;
      const end = ta.selectionEnd;
      const selected = ta.value.slice(start, end);
      const insert = `![${alt || selected || "alt text"}](${url})`;
      ta.setRangeText(insert, start, end, "end");
      setContent(ta.value);
      ta.focus();
    },
  };
}
